import { CardsComponent } from './../../components/shared/cards/cards.component';
import { HpTextAreaComponent } from './../../components/shared/hp-text-area/hp-text-area.component';
import { RampUpChecklistComponent } from './../../components/dialogs/ramp-up-checklist/ramp-up-checklist.component';
import { WalkMeComponent } from './../../components/dialogs/walk-me/walk-me.component';
import { PricebookTermsConditionComponent } from './../../components/dialogs/pricebook-terms-condition/pricebook-terms-condition.component';
import { EstimationPreviewComponent } from './../../components/dialogs/estimation-preview/estimation-preview.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { PaginatorStylesDirective } from 'src/app/directives/paginator-styles.directive';
import { SearchBoxComponent } from 'src/app/components/shared/search-box/search-box.component';
import { PaginatorRowSelectComponent } from 'src/app/components/shared/paginator-row-select/paginator-row-select.component';
import { CustomTooltipDirective } from '../../directives/custom-tooltip.directive';
import { CustomSpinnerComponent } from '../../components/shared/custom-spinner/custom-spinner.component';
import { SliceStringPipe } from '../../pipes/splice-string.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { AddSubstrateDialogComponent } from 'src/app/components/dialogs/add-substrate-dialog/add-substrate-dialog.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccessCodeComponent } from '../../components/shared/access-code/access-code.component';
import { SubstrateInfoInputComponent } from 'src/app/components/dialogs/add-substrate-dialog/substrate-info-input/substrate-info-input.component';
import { ShareSubstrateComponent } from '../../components/dialogs/add-substrate-dialog/share-substrate/share-substrate.component';
import { SnackbarComponent } from '../../components/shared/snackbar/snackbar.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TermsAndConditionsComponent } from '../../components/dialogs/terms-and-conditions/terms-and-conditions.component';
import { AcceptModalComponent } from 'src/app/components/dialogs/accept-modal/accept-modal.component';
import { CloseCaseAlertComponent } from 'src/app/components/dialogs/close-case-alert/close-case-alert.component';
import { CaseCancelDeleteAlertComponent } from 'src/app/components/dialogs/case-cancel-delete-alert/case-cancel-delete-alert.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePickerComponent } from 'src/app/components/shared/date-picker/date-picker.component';
import { CustomDatePickerComponent } from 'src/app/components/shared/custom-date-picker/custom-date-picker.component';

import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { DropdownListComponent } from 'src/app/components/shared/dropdown-list/dropdown-list.component';
import { FilterPipe } from 'src/app/pipes/filter.pipe';
import { SearchPipe } from 'src/app/pipes/search.pipe';
import { SitePrepOngoingTableComponent } from 'src/app/components/shared/site-prep-ongoing-table/site-prep-ongoing-table.component';
import { EngineersWorkloadPopupComponent } from 'src/app/components/dialogs/engineers-workload-popup/engineers-workload-popup.component';
import { ProactiveAlertsPopupComponent } from 'src/app/components/dialogs/proactive-alerts-popup/proactive-alerts-popup.component';
import { CustomerAccordianComponent } from 'src/app/components/features/customer-accordian/customer-accordian.component';
import { AddCaseDialogComponent } from 'src/app/components/dialogs/add-case-dialog/add-case-dialog.component';
import { CaseDropdownComponent } from 'src/app/components/dialogs/add-case-dialog/case-dropdown/case-dropdown.component';
import { AddCustomerPrinterDialogComponent } from 'src/app/components/dialogs/add-customer-printer-dialog/add-customer-printer-dialog.component';


import { ResellerAssignComponent } from '../../components/printos-admin-dialogs/reseller-assign/reseller-assign.component';
import { PrintosAlertMessageComponent } from '../../components/printos-admin-dialogs/printos-alert-message/printos-alert-message.component';
import { SendInvitationComponent } from '../../components/printos-admin-dialogs/send-invitation/send-invitation.component';
import { AddPrinterComponent } from '../../components/printos-admin-dialogs/add-printer/add-printer.component';
import { ContractOffersComponent } from '../../components/printos-admin-dialogs/contract-offers/contract-offers.component';
import { ContractContentComponent } from '../../components/printos-admin-dialogs/contract-content/contract-content.component';
import { ContractCodeListComponent } from '../../components/printos-admin-dialogs/contract-code-list/contract-code-list.component';
import { AddDataComponent } from '../../components/printos-admin-dialogs/add-data/add-data.component';
import { AddRegionComponent } from '../../components/printos-admin-dialogs/add-region/add-region.component';
import { ServiceModeComponent } from '../../components/printos-admin-dialogs/service-mode/service-mode.component';
import { ServiceModeRowComponent } from '../../components/printos-admin-dialogs/service-mode/service-mode-row/service-mode-row.component';
import { BusinessModelPopupComponent } from '../../components/printos-admin-dialogs/business-model-popup/business-model-popup.component';
import { CreateProductComponent } from '../../components/printos-admin-dialogs/create-product/create-product.component';
import { CustomerProfileEditComponent } from 'src/app/components/printos-admin-dialogs/customer-profile-edit/customer-profile-edit.component';
import { CustomPaginationDirective } from 'src/app/directives/custom-pagination.directive';
import { AdminPrintosHeaderComponent } from 'src/app/components/printos-admin/admin-printos-header/admin-printos-header.component';
import { UploadSitePreparationReportComponent } from 'src/app/components/dialogs/upload-site-preparation-report/upload-site-preparation-report.component';
import { RadialProgressComponent } from 'src/app/components/shared/radial-progress/radial-progress.component';
import { AddContactComponent } from 'src/app/components/dialogs/add-contact/add-contact.component';
import { EditCustomerComponent } from 'src/app/components/dialogs/edit-customer/edit-customer.component';
import { CoverageLockComponent } from 'src/app/components/shared/coverage-lock/coverage-lock.component';
import { environment } from 'src/environments/environment';
import { AutoInputComponent } from 'src/app/components/dialogs/add-customer-printer-dialog/auto-input/auto-input.component';
import { KeepHtmlPipe } from 'src/app/pipes/keep-html.pipe';
import { CustomDropdownComponent } from 'src/app/components/shared/custom-dropdown/custom-dropdown.component';
import { AddNewLocationComponent } from 'src/app/components/shared/add-new-location/add-new-location.component';
import { NewSitePrepartionComponent } from 'src/app/components/dialogs/new-site-prepartion/new-site-prepartion.component';
import { EditSitesComponent } from 'src/app/components/dialogs/edit-sites/edit-sites.component';
import { ElevateToHpComponent } from 'src/app/components/dialogs/elevate-to-hp/elevate-to-hp.component';
import { ProactiveFeedbackComponent } from 'src/app/components/shared/proactive-feedback/proactive-feedback.component';
import { LinkSitePreparationComponent } from 'src/app/components/dialogs/link-site-preparation/link-site-preparation.component';
import { UploadSiteReportComponent } from 'src/app/components/dialogs/upload-site-report/upload-site-report.component';
import { ChangeContactComponent } from 'src/app/components/dialogs/change-contact/change-contact.component';
import { PageNotFoundComponent } from 'src/app/pages/page-not-found/page-not-found.component';
import { CoverageFilterComponent } from 'src/app/components/dialogs/coverage-filter/coverage-filter.component';
import { HpDropdownComponent } from 'src/app/components/shared/hp-dropdown/hp-dropdown.component';
import { DropdownSearchPipe } from 'src/app/pipes/dropdown-search.pipe';
import { HpTextBoxComponent } from 'src/app/components/shared/hp-text-box/hp-text-box.component';
import { TableFilterComponent } from 'src/app/components/shared/table-filter/table-filter.component';
import { NestedCheckboxComponent } from 'src/app/components/shared/nested-checkbox/nested-checkbox.component';
import { SolvedAlertComponent } from 'src/app/components/dialogs/solved-alert/solved-alert.component';
import { HpFilePickerComponent } from 'src/app/components/shared/hp-file-picker/hp-file-picker.component';
import { FilterConfirmationAlertComponent } from 'src/app/components/dialogs/filter-confirmation-alert/filter-confirmation-alert.component';
import { LimitExceededComponent } from 'src/app/components/dialogs/limit-exceeded/limit-exceeded.component';
import { EstimationPrinterModelsDialogComponent } from 'src/app/components/dialogs/estimation-printer-models-dialog/estimation-printer-models-dialog.component';
import { NewContractRequestComponent } from 'src/app/components/dialogs/new-contract-request/new-contract-request.component';

import { HpLabelFilterPipe } from 'src/app/pipes/hp-label-filter.pipe';
import { AddressInputComponent } from 'src/app/components/dialogs/add-device-dialog/address-input/address-input.component';
import { EditCancelServicePlanComponent } from 'src/app/components/dialogs/edit-cancel-service-plan/edit-cancel-service-plan.component';
import { HpSingleDatePickerComponent } from 'src/app/components/shared/hp-single-date-picker/hp-single-date-picker.component';
import { SaveCancelDetailConfirmationComponent } from 'src/app/components/dialogs/save-cancel-detail-confirmation/save-cancel-detail-confirmation.component';
import { TermConditionComponent } from 'src/app/components/dialogs/new-contract-request/term-condition/term-condition.component';
import { RequestPreviewComponent } from 'src/app/components/dialogs/request-preview/request-preview.component';

import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { AddEventComponent } from 'src/app/components/dialogs/add-event/add-event.component';
import { PriceUpdateConfirmationComponent } from 'src/app/components/dialogs/price-update-confirmation/price-update-confirmation.component'

// FullCalendarModule.registerPlugins([ // register FullCalendar plugins
//   dayGridPlugin,
//   interactionPlugin
// ]);
import { ConfirmModalComponent } from 'src/app/components/dialogs/confirm-modal/confirm-modal.component';
import { DateAgoPipe } from 'src/app/pipes/date-ago.pipe';
import { EstimationConfirmationComponent } from 'src/app/components/dialogs/estimation-confirmation/estimation-confirmation.component';
import { PrinterFirmwareComponent } from 'src/app/components/dialogs/printer-firmware/printer-firmware.component';
import { AddEoslComponent } from 'src/app/components/printos-admin-dialogs/add-eosl/add-eosl.component';
import { FeaturePlanComponent } from 'src/app/components/printos-admin-dialogs/feature-plan/feature-plan.component';
import { ViewPendingFilesComponent } from 'src/app/components/dialogs/view-pending-files/view-pending-files.component';
import { RequestStatusDialogComponent } from 'src/app/components/dialogs/request-status-dialog/request-status-dialog.component';
import { CustomerPetitionPreviewComponent } from 'src/app/components/dialogs/customer-petition-preview/customer-petition-preview.component';
import { CapitalizeFirstLetterPipe } from 'src/app/pipes/capitalize-first-letter.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PrinterPlanChartComponent } from 'src/app/components/printer-plan-chart/printer-plan-chart.component';
import { VeenerLoaderBtnComponent } from 'src/app/components/shared/veener-loader-btn/veener-loader-btn.component';
import { ListUnSupportedModels } from 'src/app/components/printos-admin-dialogs/list-unsupport-models/list-unsupport-models.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { StepperComponent } from 'src/app/components/dialogs/stepper/stepper.component';
import { NoteErrorMsgComponent } from 'src/app/components/shared/note-error-msg/note-error-msg.component';
import { AddDeviceDialogComponent } from 'src/app/components/dialogs/add-device-dialog/add-device-dialog.component';
import { ProgressBarComponent } from 'src/app/components/shared/progress-bar/progress-bar.component';
import { SearchDropdownComponent } from 'src/app/components/shared/search-dropdown/search-dropdown.component';
@NgModule({ declarations: [
        SearchBoxComponent,
        DatePickerComponent,
        CustomDatePickerComponent,
        PaginatorStylesDirective,
        AddContactComponent,
        EditSitesComponent,
        ProactiveFeedbackComponent,
        EditCustomerComponent,
        PaginatorRowSelectComponent,
        CustomTooltipDirective,
        CustomSpinnerComponent,
        AccessCodeComponent,
        SnackbarComponent,
        SitePrepOngoingTableComponent,
        SliceStringPipe,
        FilterPipe,
        SearchPipe,
        KeepHtmlPipe,
        CustomPaginationDirective,
        RadialProgressComponent,
        CoverageLockComponent,
        DropdownSearchPipe,
        HpLabelFilterPipe,
        DateAgoPipe,
        CapitalizeFirstLetterPipe,
        // dialogs
        SubstrateInfoInputComponent,
        ShareSubstrateComponent,
        AddSubstrateDialogComponent,
        TermsAndConditionsComponent,
        AcceptModalComponent,
        CloseCaseAlertComponent,
        CaseCancelDeleteAlertComponent,
        DropdownListComponent,
        EngineersWorkloadPopupComponent,
        ProactiveAlertsPopupComponent,
        CustomerAccordianComponent,
        AutoInputComponent,
        ElevateToHpComponent,
        LinkSitePreparationComponent,
        UploadSiteReportComponent,
        EstimationPreviewComponent,
        SolvedAlertComponent,
        CoverageFilterComponent,
        SolvedAlertComponent,
        FilterConfirmationAlertComponent,
        LimitExceededComponent,
        EditCancelServicePlanComponent,
        SaveCancelDetailConfirmationComponent,
        ConfirmModalComponent,
        PriceUpdateConfirmationComponent,
        EstimationConfirmationComponent,
        PrinterFirmwareComponent,
        RequestStatusDialogComponent,
        CaseDropdownComponent,
        AddCaseDialogComponent,
        AddDeviceDialogComponent,
        AddNewLocationComponent,
        HpSingleDatePickerComponent,
        StepperComponent,
        AddCustomerPrinterDialogComponent,
        CustomerProfileEditComponent,
        ResellerAssignComponent,
        PrintosAlertMessageComponent,
        SendInvitationComponent,
        AddPrinterComponent,
        ContractOffersComponent,
        ContractContentComponent,
        ContractCodeListComponent,
        AddDataComponent,
        AddRegionComponent,
        ServiceModeComponent,
        ServiceModeRowComponent,
        BusinessModelPopupComponent,
        CreateProductComponent,
        ListUnSupportedModels,
        AdminPrintosHeaderComponent,
        UploadSitePreparationReportComponent,
        NewSitePrepartionComponent,
        CustomDropdownComponent,
        ChangeContactComponent,
        AddEventComponent,
        ViewPendingFilesComponent,
        AddressInputComponent,
        HpDropdownComponent,
        HpTextBoxComponent,
        PageNotFoundComponent,
        HpFilePickerComponent,
        TableFilterComponent,
        NestedCheckboxComponent,
        EstimationPrinterModelsDialogComponent,
        NewContractRequestComponent,
        PricebookTermsConditionComponent,
        TermConditionComponent,
        RequestPreviewComponent,
        RampUpChecklistComponent,
        WalkMeComponent,
        HpTextAreaComponent,
        CardsComponent,
        AddEoslComponent,
        FeaturePlanComponent,
        CustomerPetitionPreviewComponent,
        PrinterPlanChartComponent,
        VeenerLoaderBtnComponent,
        NoteErrorMsgComponent,
        ProgressBarComponent,
        SearchDropdownComponent
    ],
    exports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        TranslateModule,
        NgSelectModule,
        NgbModule,
        Ng2GoogleChartsModule,
        SearchBoxComponent,
        PaginatorRowSelectComponent,
        CustomSpinnerComponent,
        AccessCodeComponent,
        SnackbarComponent,
        DatePickerComponent,
        CustomDatePickerComponent,
        SitePrepOngoingTableComponent,
        PaginatorStylesDirective,
        CustomTooltipDirective,
        SliceStringPipe,
        FilterPipe,
        SearchPipe,
        DropdownSearchPipe,
        KeepHtmlPipe,
        CustomPaginationDirective,
        RadialProgressComponent,
        CoverageLockComponent,
        // AgmCoreModule,
        HpLabelFilterPipe,
        DateAgoPipe,
        CapitalizeFirstLetterPipe,
        // dialogs
        SubstrateInfoInputComponent,
        ShareSubstrateComponent,
        AddSubstrateDialogComponent,
        TermsAndConditionsComponent,
        MaterialModule,
        FlexLayoutModule,
        ScrollingModule,
        AcceptModalComponent,
        CloseCaseAlertComponent,
        CaseCancelDeleteAlertComponent,
        DropdownListComponent,
        EngineersWorkloadPopupComponent,
        ProactiveAlertsPopupComponent,
        CustomerAccordianComponent,
        AddNewLocationComponent,
        ElevateToHpComponent,
        LinkSitePreparationComponent,
        UploadSiteReportComponent,
        EstimationPreviewComponent,
        SolvedAlertComponent,
        CoverageFilterComponent,
        SolvedAlertComponent,
        EstimationPreviewComponent,
        FilterConfirmationAlertComponent,
        LimitExceededComponent,
        AddressInputComponent,
        EditCancelServicePlanComponent,
        SaveCancelDetailConfirmationComponent,
        AddEventComponent,
        ConfirmModalComponent,
        PriceUpdateConfirmationComponent,
        EstimationConfirmationComponent,
        PrinterFirmwareComponent,
        ViewPendingFilesComponent,
        RequestStatusDialogComponent,
        AutoInputComponent,
        CaseDropdownComponent,
        AddCaseDialogComponent,
        AddCustomerPrinterDialogComponent,
        CustomerProfileEditComponent,
        ResellerAssignComponent,
        PrintosAlertMessageComponent,
        SendInvitationComponent,
        AddPrinterComponent,
        ContractOffersComponent,
        ContractContentComponent,
        ContractCodeListComponent,
        AddDataComponent,
        AddRegionComponent,
        ServiceModeComponent,
        ServiceModeRowComponent,
        BusinessModelPopupComponent,
        CreateProductComponent,
        ListUnSupportedModels,
        AdminPrintosHeaderComponent,
        UploadSitePreparationReportComponent,
        AddContactComponent,
        EditSitesComponent,
        ProactiveFeedbackComponent,
        NewSitePrepartionComponent,
        CustomDropdownComponent,
        EditCustomerComponent,
        ChangeContactComponent,
        HpDropdownComponent,
        HpTextBoxComponent,
        HpFilePickerComponent,
        TableFilterComponent,
        NestedCheckboxComponent,
        EstimationPrinterModelsDialogComponent,
        HpSingleDatePickerComponent,
        NewContractRequestComponent,
        PricebookTermsConditionComponent,
        TermConditionComponent,
        RequestPreviewComponent,
        RampUpChecklistComponent,
        WalkMeComponent,
        FullCalendarModule,
        HpTextAreaComponent,
        CardsComponent,
        AddEoslComponent,
        FeaturePlanComponent,
        PrinterPlanChartComponent,
        VeenerLoaderBtnComponent,
        NoteErrorMsgComponent,
        StepperComponent,
        ProgressBarComponent,
        SearchDropdownComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        RouterModule,
        ReactiveFormsModule,
        TranslateModule,
        NgSelectModule,
        FormsModule,
        MaterialModule,
        FlexLayoutModule,
        ScrollingModule,
        NgbModule,
        MatPaginatorModule,
        // AgmCoreModule.forRoot({
        //     apiKey: environment.agmkey,
        //     libraries: ['places']
        // }),
        Ng2GoogleChartsModule,
        FullCalendarModule
       ],
        providers:[
            provideHttpClient(withInterceptorsFromDi())
        ] })
export class SharedModule { }